import { useSelector, shallowEqual } from 'react-redux';

/**
 * Redux selector for product compare state
 */
const productCompareSelector = state =>
    state.productCompare || {
        isCompareModeEnabled: false,
        selectedProducts: [],
        comparisonData: null,
        comparisonError: null
    };

/**
 * Hook to read the full `productCompare` slice from Redux.
 * Returns the mode flag, selected products, comparison data, and comparison error.
 */
export const useCompareState = () => {
    return useSelector(productCompareSelector, shallowEqual);
};

/**
 * Hook to read product comparison API state from Redux (`productCompare`).
 *
 * @returns {{ comparisonData: object|null, comparisonError: Error|null }}
 *   - `comparisonData` — payload from the ProductComparison query (e.g. `{ skus: [...] }`), or `null` before the first successful fetch completes.
 *   - `comparisonError` — value from a failed fetch (typically an `Error`), or `null` when there is no error.
 */
export const useComparisonData = () => {
    const { comparisonData = null, comparisonError = null } = useSelector(productCompareSelector, shallowEqual);

    return { comparisonData, comparisonError };
};

export default useComparisonData;
